import React, { useState } from 'react';
import { FaPlayCircle } from 'react-icons/fa';
import { motion } from 'framer-motion';

const VideoGrid = ({ works }) => {
  const [selectedVideos, setSelectedVideos] = useState({});

  const handleVideoClick = (workIndex, videoId) => {
    // Clean up the video ID by splitting at '?'
    const cleanedVideoId = videoId.split("?")[0];
    
    // Update the selected video for this specific work
    setSelectedVideos(prev => ({
      ...prev,
      [workIndex]: cleanedVideoId
    }));
  };

  return (
    <div className="container mx-auto">
      {works.map((work, workIndex) => (
        <div key={workIndex} className="p-6 rounded-lg mb-12">
          <div className="grid gap-4">
            {work.videos && work.videos.length > 0 && (
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {work.videos.map((video, videoIdx) => {
                  const cleanedVideoId = video.videoId.split("?")[0];
                  const thumbnailUrl = `https://img.youtube.com/vi/${cleanedVideoId}/hqdefault.jpg`;
                  const isVideoSelected = selectedVideos[workIndex] === cleanedVideoId;

                  return (
                    <motion.div 
                      key={videoIdx}
                      className="relative cursor-pointer"
                      whileHover={{ scale: 1.05 }}
                      transition={{ type: "spring", stiffness: 300 }}
                    >
                      {isVideoSelected ? (
                        <iframe
                          className="w-full aspect-video rounded-lg"
                          src={`https://www.youtube.com/embed/${cleanedVideoId}?autoplay=1`}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <div 
                          className="relative"
                          onClick={() => handleVideoClick(workIndex, cleanedVideoId)}
                        >
                          <img
                            className="w-full aspect-video object-cover opacity-80 rounded-lg"
                            src={thumbnailUrl}
                            alt="Video Thumbnail"
                          />
                          <div className="absolute inset-0 flex justify-center items-center">
                            <FaPlayCircle
                              size="80px"
                              className="text-white opacity-75"
                            />
                          </div>
                        </div>
                      )}
                    </motion.div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VideoGrid;